"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var setSaleBannerVisibility = function setSaleBannerVisibility(pageProps, banner) {
  if (!banner || !pageProps) return false;
  if (pageProps.pageType === "category") {
    return setSalesBannerVisibilityForCategoryPage(banner, pageProps.categoryId);
  } else if (pageProps.pageType === "product") {
    return setSalesBannerVisibilityForProductPage(banner, pageProps.product);
  }
};
var setSalesBannerVisibilityForCategoryPage = function setSalesBannerVisibilityForCategoryPage(banner, categoryId) {
  if (!(banner !== null && banner !== void 0 && banner.showInCategory)) {
    return false;
  }
  if (banner.showInCategory && !banner.categories) {
    return true;
  }
  if (banner.categories.indexOf(parseInt(categoryId)) > -1) {
    return true;
  }
  return false;
};
var setSalesBannerVisibilityForProductPage = function setSalesBannerVisibilityForProductPage(banner, product) {
  var _product$category$ids, _product$category, _product$collection, _banner$categories$fi;
  if (!(banner !== null && banner !== void 0 && banner.showInProduct)) {
    return false;
  }
  if (banner.showInProduct && !banner.categories) {
    return true;
  }
  var bannerCategoriesAndCollections = {
    categoryIds: (_product$category$ids = product === null || product === void 0 ? void 0 : (_product$category = product.category) === null || _product$category === void 0 ? void 0 : _product$category.ids) !== null && _product$category$ids !== void 0 ? _product$category$ids : [],
    collection: (product === null || product === void 0 ? void 0 : (_product$collection = product.collection) === null || _product$collection === void 0 ? void 0 : _product$collection.id) && parseInt(product.collection.id)
  };
  if (((_banner$categories$fi = banner.categories.filter(function (category) {
    return bannerCategoriesAndCollections.categoryIds.includes(category);
  })) === null || _banner$categories$fi === void 0 ? void 0 : _banner$categories$fi.length) > 0 || banner.categories.indexOf(bannerCategoriesAndCollections.collection) > -1) {
    return true;
  }
  return false;
};
var _default = setSaleBannerVisibility;
exports["default"] = _default;